/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	PracticeCertificateState,
	PracticeCertificateStateFromJSON,
	PracticeCertificateStateFromJSONTyped,
	PracticeCertificateStateToJSON,
} from "./PracticeCertificateState";
import {
	PracticeQualificationDTO,
	PracticeQualificationDTOFromJSON,
	PracticeQualificationDTOFromJSONTyped,
	PracticeQualificationDTOToJSON,
} from "./PracticeQualificationDTO";

/**
 *
 * @export
 * @interface PracticeCertificateUpdateDTO
 */
export interface PracticeCertificateUpdateDTO {
	/**
	 *
	 * @type {number}
	 * @memberof PracticeCertificateUpdateDTO
	 */
	workHoursPerDay?: number;
	/**
	 *
	 * @type {string}
	 * @memberof PracticeCertificateUpdateDTO
	 */
	observations?: string | null;
	/**
	 *
	 * @type {Array<PracticeQualificationDTO>}
	 * @memberof PracticeCertificateUpdateDTO
	 */
	qualifiers?: Array<PracticeQualificationDTO> | null;
	/**
	 *
	 * @type {PracticeCertificateState}
	 * @memberof PracticeCertificateUpdateDTO
	 */
	state?: PracticeCertificateState;
}

export function PracticeCertificateUpdateDTOFromJSON(
	json: any
): PracticeCertificateUpdateDTO {
	return PracticeCertificateUpdateDTOFromJSONTyped(json, false);
}

export function PracticeCertificateUpdateDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PracticeCertificateUpdateDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		workHoursPerDay: !exists(json, "workHoursPerDay")
			? undefined
			: json["workHoursPerDay"],
		observations: !exists(json, "observations")
			? undefined
			: json["observations"],
		qualifiers: !exists(json, "qualifiers")
			? undefined
			: json["qualifiers"] === null
			? null
			: (json["qualifiers"] as Array<any>).map(
					PracticeQualificationDTOFromJSON
			  ),
		state: !exists(json, "state")
			? undefined
			: PracticeCertificateStateFromJSON(json["state"]),
	};
}

export function PracticeCertificateUpdateDTOToJSON(
	value?: PracticeCertificateUpdateDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		workHoursPerDay: value.workHoursPerDay,
		observations: value.observations,
		qualifiers:
			value.qualifiers === undefined
				? undefined
				: value.qualifiers === null
				? null
				: (value.qualifiers as Array<any>).map(PracticeQualificationDTOToJSON),
		state: PracticeCertificateStateToJSON(value.state),
	};
}
